<template>
  <px-custom-dialog
    transition="fadet"
    :width="dialogWidth"
    v-model="dialog"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
        <v-btn
          class="normal-btn-text elevation-0 rounded-tag-small"
          small
          v-on="on"
        >
          Vincular NF
        </v-btn>
      </slot>
    </template>
    <template v-slot:title>
      Vincular nota fiscal
    </template>
    <div v-if="compra.id && dialog">
      <v-row>
        <v-col cols="12">
          <div class="caption font-weight-bold">
            Tipo de vínculo {{ this.tipoVinculo }}
          </div>
          <v-radio-group v-model="tipoVinculo">
            <v-radio :disabled="!hasModuleNotaFiscal"
                     :label="tiposVinculos.LINK.description"
                     :value="tiposVinculos.LINK.key"></v-radio>
            <v-radio :label="tiposVinculos.MANUAL.description"
                     :value="tiposVinculos.MANUAL.key"></v-radio>
          </v-radio-group>
          <div v-if="tipoVinculo === tiposVinculos.MANUAL.key">
            <px-cadastro-nota-fiscal-vinculo-manual ref="manualForm"
                                                    :compra="compra"
                                                    :nota-fiscal-manual="notaFiscalManual"/>
          </div>
          <div v-else-if="tipoVinculo === tiposVinculos.LINK.key">
            <px-cadastro-nota-fiscal-vinculo-nota-fiscal v-model="notaFiscalVinculo"
                                                         :compra="compra" :links="links"/>
          </div>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="rounded-tag-small"
            label="Observações internas"
            counter="2000"
            rows="2"
            v-model="observacaoInterna"
          />
        </v-col>
      </v-row>
    </div>
    <template v-slot:actions>
      <v-btn class="rounded-tag-small normal-btn-text elevation-0"
             color="primary"
             :disabled="!isSubmitBtnEnabled"
             :loading="loading"
             @click="onClickVincular">
        Vincular NF
      </v-btn>
      <v-btn class="rounded-tag-small normal-btn-text elevation-0"
             :disabled="loading"
             @click="onCloseDialog">
        Fechar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import TipoLinkNotaFiscalCompra from '@/enums/tipo-link-nota-fiscal-compra';
import CadastroNotaFiscalVinculoLink
  from '@/modules/notas-fiscais/vinculo/CadastroNotaFiscalVinculoLink.vue';
import CadastroNotaFiscalVinculoManual
  from '@/modules/notas-fiscais/vinculo/CadastroNotaFiscalVinculoManual.vue';
import NotasFiscaisCompraLinkService
  from '@/modules/notas-fiscais/notas-fiscais-compra-link-service';
import { mapGetters } from 'vuex';

export default {
  props: {
    compra: {
      type: Object,
      required: true,
    },
    links: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      notaFiscalVinculo: null,
      notaFiscalManual: {
        chaveAcesso: null,
        notaFiscalFile: null,
      },
      observacaoInterna: null,
      tipoVinculo: TipoLinkNotaFiscalCompra.keys.LINK.key,
      tiposVinculos: TipoLinkNotaFiscalCompra.keys,
    };
  },
  computed: {
    ...mapGetters('entidade', ['hasModuleNotaFiscal']),
    isSmall() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    dialogWidth() {
      return this.isSmall ? '95%' : '900px';
    },
    isSubmitBtnEnabled() {
      if (this.tipoVinculo === this.tiposVinculos.MANUAL.key) {
        return true;
      }
      return this.tipoVinculo === this.tiposVinculos.LINK.key && this.notaFiscalVinculo;
    },
  },
  methods: {
    isFormValid() {
      if (this.tipoVinculo === this.tiposVinculos.MANUAL.key) {
        return this.$refs.manualForm?.isValid();
      }
      return true;
    },
    onCloseDialog() {
      this.dialog = false;
    },
    buildPayload() {
      const payload = {
        linkType: this.tipoVinculo,
        compra: {
          id: this.compra.id,
        },
        observacaoInterna: this.observacaoInterna,
      };

      if (this.tipoVinculo === this.tiposVinculos.LINK.key) {
        payload.notaFiscal = {
          id: this.notaFiscalVinculo.id,
        };
      } else {
        payload.chaveAcesso = this.notaFiscalManual.chaveAcesso;
        payload.notaFiscalFile = this.notaFiscalManual.notaFiscalFile[0] || null;
      }

      return payload;
    },
    criarVinculo() {
      if (!this.isFormValid()) {
        return;
      }
      this.loading = true;
      NotasFiscaisCompraLinkService.createLink(this.compra.id, this.buildPayload())
        .then(({ data }) => {
          this.$emit('change', data);
          this.onCloseDialog();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickVincular() {
      this.criarVinculo();
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue) {
        this.notaFiscalVinculo = null;
        this.notaFiscalManual = {
          chaveAcesso: null,
          notaFiscalFile: null,
        };
        this.observacaoInterna = null;
        this.tipoVinculo = this.hasModuleNotaFiscal ? TipoLinkNotaFiscalCompra.keys.LINK.key
          : TipoLinkNotaFiscalCompra.keys.MANUAL.key;
      }
    },
  },
  components: {
    pxCadastroNotaFiscalVinculoNotaFiscal: CadastroNotaFiscalVinculoLink,
    pxCadastroNotaFiscalVinculoManual: CadastroNotaFiscalVinculoManual,
  },
};
</script>
